import { computed, Injectable, signal } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { StorageService } from './storage.service';
import { CreateUtenteDTO, Utente } from '../models/utenti.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UtentiService {
  apiVersion = 'v1';
  private apiUrl = `${environment.apiUrl}/api/${this.apiVersion}/users`;

  private allUsers = signal<Utente[]>([]);

  utenti = computed(() => this.allUsers());

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
  ) {}

  getAll() {
    return this.http.get<Utente[]>(this.apiUrl);
  }

  fetchAll() {
    this.getAll().subscribe({
      next: utenti => this.allUsers.set(utenti),
    });
  }

  updateOrganization(username: string, organization: string): Observable<any> {
    return this.http.patch(`${this.apiUrl}/update`, {
      username: username,
      organization: organization,
    });
  }

  createUser(dto: CreateUtenteDTO): Observable<any> {
    return this.http.post(this.apiUrl, dto);
  }

  updateUser(
    username: string,
    data: { givenName?: string; email?: string; organization?: string },
  ): Observable<any> {
    return this.http.patch(`${this.apiUrl}/update`, {
      username,
      ...data,
    });
  }

  resetPassword(username: string): Observable<any> {
    return this.http.patch(`${this.apiUrl}/reset-pwd`, { username });
  }
}
